module.exports = __webpack_public_path__ + "static/fesobi-8d7a5c83ddb1ddf88b12053a1325f181.jpg";